import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { Chip } from '@shared/ui-components/chip/chip';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { type SearchCmsContent } from '../../../../graphql/get-search-cms-content';
import styles from './filter-footer.module.scss';
type FilterFooterProps = {
  className?: string;
  formId: string;
  handleReset: () => void;
  searchCmsContent: SearchCmsContent;
};
export const FilterFooter = t0 => {
  const $ = _c(12);
  const {
    className,
    formId,
    handleReset,
    searchCmsContent
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classnames(styles["filter-footer"], className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleReset || $[3] !== searchCmsContent.generic.reset) {
    t2 = <Chip label={searchCmsContent.generic.reset} onClick={handleReset} theme={ChipTheme.Light} />;
    $[2] = handleReset;
    $[3] = searchCmsContent.generic.reset;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = searchCmsContent?.searchPage?.FilterResultsLabel || "Filter results";
  let t4;
  if ($[5] !== formId || $[6] !== t3) {
    t4 = <Chip className={styles["filter-footer__apply-button"]} form={formId} label={t3} theme={ChipTheme.Emphasis} type="submit" />;
    $[5] = formId;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <footer className={t1}>{t2}{t4}</footer>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};